var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('div',{staticClass:"preloader"},[_c('img',{attrs:{"src":require("../images/preloader.svg"),"alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }